import React from "react";
import "../styles/sections.css";

const Contact = ({ translations }) => {
  return (
    <section className="section contact">
      <div className="container">
        <h2>{translations.contactTitle}</h2>
        <p>{translations.contactDescription}</p>
        {/* Embed Google Form */}
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSc6q_L4I08_C0Q4qwn_rANvdjh5ozW4ybYCCDqM1KNy_OB4Sw/viewform?embedded=true"
          width="100%"
          height="800"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="Contact Form"
        >
          Loading…
        </iframe>
      </div>
    </section>
  );
};

export default Contact;